<template>
  <button :class="this.customColor+' button button-secondary'+(this.fullWidth?' full-width':'')"
          :disabled="!!this.disabled"
  >
    {{ text }}
  </button>
</template>

<style scoped>
.button {
  appearance: none;
  -webkit-appearance: none;
  background-color: var(--son-dunkelgrau);
  border: 2px solid var(--son-dunkelgrau);
  color: white;
  text-transform: uppercase;
  height: 50px;
  padding: 0 18px;
  font-weight: 500;
  cursor: pointer;
}

.button.full-width {
  width: 100%;
  max-width: 400px;
}

.button-secondary.red {
  border-color: var(--error);
  color: var(--error);
}

.button:disabled, .button-secondary.red:disabled {
  border-color: var(--disabled-grey);
  color: var(--disabled-grey);
  cursor: not-allowed;
}

.button-secondary {
  background: none;
  color: var(--son-dunkelgrau);
  border: 2px solid var(--son-dunkelgrau);
}
</style>

<script>
export default {
  props: [
    "text",
    "customColor",
    "disabled",
    "fullWidth",
  ],
}
</script>